import toast from "react-hot-toast";
import { environment } from "../environments/environment";

export const restrictGenerationLimit = (
  service: string,
  count: number,
  domain?: boolean | undefined
): boolean => {
  const MAXIMUM_GENERATION_LIMIT = parseInt(
    environment.MAXIMUM_GENERATION_LIMIT || "10",
    10
  );
  if (count >= MAXIMUM_GENERATION_LIMIT && !domain) {
    toast.error(
      `You have reached the maximum limit of ${MAXIMUM_GENERATION_LIMIT} ${service}s. Please delete some ${service}s from your profile to generate more.`,
      {
        duration: 4000,
        position: "top-center",
        style: {
          background: "#fef2f2",
          color: "#b91c1c",
          fontFamily: "Inter, sans-serif",
          fontSize: "14px",
          padding: "12px",
          borderRadius: "8px",
          maxWidth: "400px",
        },
      }
    );
    return false;
  }
  return true;
};
